import React from 'react'
import injectSheet from 'react-jss'
import styles from './paper.styles'
import classNames from 'classnames'

const Paper = ({ classes, className, children }) => (
  <div className={classNames(classes.paper, className)}>{children}</div>
)

export default injectSheet(styles)(Paper)
